import axios from 'src/api/axios.config'

export const asyncGetPetrolDetailById = async (param) => axios.post(`/backstage/petrol/detail`, param).then(({ data }) => data.success ? data.data : {})
export const getPetrolDetailById = (param, callback) => {
  const url = '/backstage/petrol/detail'
  axios.post(url, param).then(resp => {
    callback(resp.data)
  }).catch(err => {
    console.log('err is ', err)
  })
}

export const asyncGetPetrolList = async (param) => axios.post(`/backstage/petrol/list`, param).then(({ data }) => data.success ? data.data : {})
export const getPetrolList = (param, callback) => {
  const url = '/backstage/petrol/list'
  axios.post(url, param).then(resp => {
    callback(resp.data)
  }).catch(err => {
    console.log('err is ', err)
  })
}

export const getPetrolListECharts = (param, callback) => {
  const url = '/backstage/petrol/list.echarts'
  axios.post(url, param).then(resp => {
    callback(resp.data)
  }).catch(err => {
    console.log('err is ', err)
  })
}

export const getPetrolListTotal = (callback) => {
    const url = '/backstage/petrol/list.total'
    axios.get(url).then(resp => {
        callback(resp.data)
    }).catch(err => {
        console.log('err is ', err)
    })
}

export const petrolAdd = (param, callback) => {
  const url = '/backstage/petrol/add'
  axios.post(url, param).then(resp => {
    callback(resp.data)
  }).catch(err => {
    console.log('err is ', err)
  })
}

export const petrolModify = (param, callback) => {
  const url = '/backstage/petrol/modify'
  axios.post(url, param).then(resp => {
    callback(resp.data)
  }).catch(err => {
    console.log('err is ', err)
  })
}

export const petrolDel = (param, callback) => {
  const url = '/backstage/petrol/delete'
  axios.post(url, param).then(resp => {
    callback(resp.data)
  }).catch(err => {
    console.log('err is ', err)
  })
}
